import React from "react";

import {
  SpiritualDomainTask1,
  SpiritualDomainTask2,
  SpiritualDomainTask3,
  SpiritualDomainTask4,
  SpiritualDomainTask5,
  SpiritualDomainTask6,
  SpiritualDomainTask7,
  SpiritualDomainTask8,
  SpiritualDomainTask9,
  SpiritualDomainTaskPlaceholder
} from "./SpiritualDomainTasks";

interface SpiritualDomainTaskFactoryProps {
  slideKey: string;
  setHeader: (header: string) => void;
  questionCompleter: any;
}

const SpiritualDomainTaskFactory: React.FC<SpiritualDomainTaskFactoryProps> = (
  props
) => {
  const { slideKey, setHeader, questionCompleter } = props;

  const getCurrentSlide = () => {
    switch (slideKey) {
      case "SpiritualDomainTask1":
        return SpiritualDomainTask1;
      case "SpiritualDomainTask2":
        return SpiritualDomainTask2;
      case "SpiritualDomainTask3":
        return SpiritualDomainTask3;
      case "SpiritualDomainTask4":
        return SpiritualDomainTask4;
      case "SpiritualDomainTask5":
        return SpiritualDomainTask5;
      case "SpiritualDomainTask6":
        return SpiritualDomainTask6;
      case "SpiritualDomainTask7":
        return SpiritualDomainTask7;
      case "SpiritualDomainTask8":
        return SpiritualDomainTask8;
      case "SpiritualDomainTask9":
        return SpiritualDomainTask9;
      default:
        return SpiritualDomainTaskPlaceholder;
    }
  };

  const currentSlide = getCurrentSlide()!(questionCompleter);

  setHeader(currentSlide.header);

  return <>{currentSlide.content}</>;
};

export default SpiritualDomainTaskFactory;
